import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page10({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Run 6 Rounds'
				isNumberd={true}
				rounds={[
					[
						{header: 'Type', value: 'ALPHA'},
						{header: 'C.C.M.R’s', value: 'INCLINE DUMBBELL FLYES'},
						{header: 'REPS Sec / Min', value: '6 - 8'},
						{header: 'WEIGHT LEVEL', value: 'Mild --> Heavy'},
					],
					[
						{header: 'Type', value: 'BETA'},
						{header: 'C.C.M.R’s', value: 'DIPS'},
						{header: 'REPS Sec / Min', value: '10'},
						{header: 'WEIGHT LEVEL', value: 'Body Weight'},
					],
					[
						{header: 'Type', value: 'BETA'},
						{header: 'C.C.M.R’s', value: 'RESISTANCE BAND FLIES'},
						{header: 'REPS Sec / Min', value: '10'},
						{header: 'WEIGHT LEVEL', value: 'Light -> Heavy'},
					],
				]}
			/>
			<p style={style.takeABreakTextStyle()}>Take a 1 - 2 minute break</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
